export enum Platform {
  Tok = 'TikTok',
  Gram = 'Instagram'
}
